import React from 'react'
import { SelfCheckOutState } from '@/models/self-checkout'
import { useInitializeFrontTablet } from '@/hooks/use-initialize-front-tablet'

type Props = {
  state?: SelfCheckOutState
}
export const FrontTabletLayout: React.FC<Props> = props => {
  useInitializeFrontTablet(props.state)

  return <div css={{ '*': { fontFamily: 'Noto Sans JP' }, color: '#272727' }}>{props.children}</div>
}
